import { ThemeTransitionDuration } from "@insite/mobius/globals/baseTheme";
import { css } from "styled-components";

export type TransitionDuration = keyof ThemeTransitionDuration | number;

export const transitionStyles = (duration: TransitionDuration, animation: string, properties?: string[]) => {
    const _properties = properties?.length ? properties : ["all"];

    return css`
        ${({ theme }) => {
            const _duration = typeof duration === "string" ? theme.transition.duration[duration] : duration;

            return _properties.map(y => `${y} ${_duration}ms ${animation}`).join(", ");
        }}
    `;
};
